import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { findProducts } from "../Redux/Customers/Product/Action";

const Collection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate hook
  const { customersProduct } = useSelector((store) => store);
  
  const audioRef = useRef(null); // Create a ref for the audio element

  useEffect(() => {
    const data = {
      category: "", // You can add filters if needed
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: "price_low",
      pageNumber: 1,
      pageSize: 10,
      stock: "in_stock", // or other filters if needed
    };
    dispatch(findProducts(data));
  }, [dispatch]);

  const handleProductClick = (productId) => {
    if (audioRef.current) {
      audioRef.current.play();
    }
    audioRef.current.play();
    setTimeout(() => {
      navigate(`/products/${productId}`);
    }, 1000);

  };

  return (
    <div className="relative">
      {/* Background */}
      <div className="absolute inset-0 -z-10 h-full w-full items-center px-5 py-24 bg-[radial-gradient(125%_125%_at_50%_10%,#000_40%,#63e_100%)]"></div>

      {/* Featured Collection Section */}
      <section className="flex flex-col px-4 sm:px-8 lg:px-16">
        {/* Header Section */}
        <div className="border-b-2 flex justify-between items-center py-4">
          <h1 className="text-3xl sm:text-4xl font-bold text-white">Featured Collection</h1>
          <button className="text-xl sm:text-2xl font-semibold text-white hover:text-pink-300 transition duration-300">
            View All
          </button>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-8 p-2 sm:p-3 lg:p-5">
          {customersProduct?.products?.map((product) => (
            <div
              key={product._id}
              className="text-center cursor-pointer"
              onClick={() => handleProductClick(product?._id)} // Navigate on click and play audio
            >
              <img
                className="border shadow-md shadow-pink-500 border-pink-900 rounded w-full h-[300px] sm:h-[350px] object-cover"
                src={product?.imageUrl}
                alt={product?.title}
              />
              <div className="flex justify-between items-center mt-4 px-2">
                <p className="text-white text-sm sm:text-base">{product?.title}</p>
                <p className="text-white text-sm sm:text-base">{product?.discountedPrice} ₹</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Audio element */}
      <audio ref={audioRef} src="/audio1.mp3" />
    </div>
  );
};

export default Collection;
